<template>
	<v-container fluid fill-height class="content-pad-vert">
		<v-layout row wrap>
			<v-flex x12 sm10 md6 offset-sm1 offset-md3 class="pt-5">
				<v-card>
					<v-card-title>
						<h2 class="text-xs-center">Settings</h2>
					</v-card-title>
					<v-card-text>
						<v-divider class="mb-4"></v-divider>
						<h3>Change password</h3>
						<v-form v-model="valid" ref="form" lazy-validation>
							<v-text-field
								v-model="oldPassword"
								label="Old Password (if applicable)"
								min="8"
								:append-icon="e1 ? 'visibility' : 'visibility_off'"
								:append-icon-cb="() => (e1 = !e1)"
								:type="e1 ? 'password' : 'text'"
								counter
							></v-text-field>
							<v-text-field
								v-model="newPassword"
								label="New Password"
								min="8"
								:rules="[rules.required, rules.min_length, rules.include_lower, rules.include_upper, rules.include_number, rules.include_special]"
								:append-icon="e2 ? 'visibility' : 'visibility_off'"
								:append-icon-cb="() => (e2 = !e2)"
								:type="e2 ? 'password' : 'text'"
								counter
							></v-text-field>
							<v-text-field
								v-model="confirmPassword"
								label="Confirm Password"
								min="8"
								:rules="[rules.required, rules.password_match]"
								:append-icon="e3 ? 'visibility' : 'visibility_off'"
								:append-icon-cb="() => (e3 = !e3)"
								:type="e3 ? 'password' : 'text'"
								counter
							></v-text-field>
							<div
								style="color: red;"
								v-for="(e, index) in error"
								:key="index"
							>
								{{ e }}
							</div>
							<div style="color: green;">
								{{ success }}
							</div>
							<v-btn @click="update" :disabled="!valid">
								Update Password
							</v-btn>
						</v-form>

						<v-divider class="mt-4 mb-4"></v-divider>

						<h3>Emails</h3>

						<v-divider class="mt-4 mb-4"></v-divider>

						<h3>Social Accounts</h3>

						<v-list>
							<v-list-tile avatar v-for="acc in socialAccounts" v-bind:key="acc.id">
								<v-list-tile-avatar>
									<v-icon>fa-{{ acc.provider }}</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>{{ acc.provider }}</v-list-tile-title>
									<v-list-tile-sub-title>Added: {{ acc.date_joined }}</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-btn icon ripple>
										<v-icon color="info">fa-info</v-icon>
									</v-btn>
								</v-list-tile-action>
							</v-list-tile>
							<!-- <v-list-tile avatar v-if="!socialAccounts.find(obj => obj.provider === 'facebook')">
								<v-list-tile-avatar>
									<v-icon>fa-facebook</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>facebook</v-list-tile-title>
									<v-list-tile-sub-title>Connect Facebook</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-btn icon ripple @click="alert('Facebook connect coming soon')">
										<v-icon color="info">fa-plus</v-icon>
									</v-btn>
								</v-list-tile-action>
							</v-list-tile>
							<v-list-tile avatar v-if="!socialAccounts.find(obj => obj.provider === 'google')">
								<v-list-tile-avatar>
									<v-icon>fa-google</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>facebook</v-list-tile-title>
									<v-list-tile-sub-title>Connect Google</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									<v-btn icon ripple @click="alert('Google connect coming soon')">
										<v-icon color="info">fa-plus</v-icon>
									</v-btn>
								</v-list-tile-action>
							</v-list-tile> -->
						</v-list>

						<v-divider class="mt-4 mb-4"></v-divider>

						<h3>Payments</h3>

						<p>Premium status: {{ user.is_premium ? 'Active' : 'Not Premium' }}</p>

						<p>Please <a href="mailto:support@wrkprty.com" style="color:red!important;">email support@wrkprty.com</a> to cancel membership</p>

						<v-btn v-if="!user.is_premium" color="success">
							Get Premium
						</v-btn>

						<v-divider class="mt-4 mb-4"></v-divider>

						<h3>Disable Account</h3>
						<a href="mailto:support@wrkprty.com?subject=WRKPRTY%20Close%20Account%20Request" style="color:red!important;">Email support@wrkprty.com</a> to disable your account.
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import axios from 'axios'

import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			socialAccounts: [],
			e1: true,
			e2: true,
			e3: true,
			oldPassword: '',
			newPassword: '',
			confirmPassword: '',
			error: [],
			success: '',
			valid: true,
			rules: {
				required: value => !!value || 'Required.',
				min_length: value =>
					value.length > 7 || 'Minimum length is 8 characters',
				include_lower: value => {
					return /.*[a-z].*/.test(value) || 'Must include a lowercase letter'
				},
				include_upper: value => {
					return /.*[A-Z].*/.test(value) || 'Must include an uppercase letter'
				},
				include_number: value => {
					return /.*[0-9].*/.test(value) || 'Must include a number'
				},
				include_special: value => {
					return (
						/.*[!@#$%^*?&~=+|\\\/\(\)\{\[\]}\-_\<\>\.].*/.test(value) ||
						'Must include a special character'
					)
				},
				password_match: value => {
					return this.newPassword === value || "Passwords don't match"
				}
			}
		}
	},
	created() {
		axios
			.get('/rest-auth/socialaccounts/')
			.then(response => {
				console.log(response)
				this.socialAccounts = response.data
			})
			.catch(error => {
				console.error(error)
			})
	},
	computed: {
		...mapGetters(['user'])
	},
	methods: {
		update() {
			if (this.$refs.form.validate()) {
				if (this.newPassword === this.confirmPassword) {
					axios
						.put('/api/v1/settings/change-password/', {
							old_password: this.oldPassword ? this.oldPassword : '12345',
							new_password: this.newPassword
						})
						.then(response => {
							this.error = []
							this.success = response.data
						})
						.catch(error => {
							console.error(error)
							this.error = []
							for (let i in error.response.data) {
								this.error.push(error.response.data[i])
							}
						})
				} else {
					this.error = ['Password and confirmation do not match']
				}
			}
		},
		alert(msg) {
			alert(msg)
		}
	}
}
</script>
